export const padDigits = (
  value: string | number,
  length: number = 2,
): string => {
  return String(value).padStart(length, '0')
}

export const formatDateOnlyLocal = (date: Date): string => {
  if (isNaN(date.getTime())) {
    return 'Invalid Date'
  }
  const year = date.getFullYear()
  const month = padDigits(date.getMonth() + 1, 2)
  const day = padDigits(date.getDate(), 2)
  return `${year}-${month}-${day}`
}
